import {ComponentValue, Config} from './components/types'

// Configuration object
export const pulsehealthConfig: Config = {
  'Screening Data': [
    {
      component: 'UnitConvertibleInput',
      name: 'Height (cm)',
      otherProps: {
        measurement: 'length',
        label: 'Height',
      },
    },
    {
      component: 'UnitConvertibleInput',
      name: 'Weight (kg)',
      otherProps: {
        measurement: 'mass',
        label: 'Weight',
      },
    },
    {
      component: 'CalculatedField',
      name: 'BMI',
      otherProps: {
        calculation: (data: ComponentValue[]) => {
          const height = data.find((item) => item.name === 'Height (cm)')?.value
          const weight = data.find((item) => item.name === 'Weight (kg)')?.value
          if (!height || !weight) return undefined
          return (
            Number(weight) /
            ((Number(height) / 100) * (Number(height) / 100))
          ).toFixed(2)
        },
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'SelectDataInput',
      name: 'Smoker',
      otherProps: {
        values: ['Yes', 'No', 'Not any more'],
      },
    },
    {
      component: 'TextDataInput',
      name: 'Number Per Day',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Vape',
      otherProps: {
        values: ['Yes - Daily', 'Yes - Occasionally', 'Not any more', 'No'],
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 1 - Sys',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 1 - Dia',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Blood Pressure 1 - Arm',
      otherProps: {
        values: ['Left', 'Right'],
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 2 - Sys',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 2 - Dia',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Blood Pressure 2 - Arm',
      otherProps: {
        values: ['Left', 'Right'],
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 3 - Sys',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 3 - Dia',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Blood Pressure 3 - Arm',
      otherProps: {
        values: ['Left', 'Right'],
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
  ],
  Tests: [
    {
      component: 'SelectDataInput',
      name: 'ECG Test Status',
      otherProps: {
        values: ['Pending', 'Not applicable', 'Complete'],
      },
    },
    {
      component: 'NamedFileInput',
      name: 'ECG Results',
      otherProps: {},
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'NamedFileInput',
      name: 'ECG Report',
      otherProps: {},
    },
    {
      component: 'SelectDataInput',
      name: 'Blood Test Status',
      otherProps: {
        values: ['Pending', 'Not applicable', 'Complete'],
      },
    },
    {
      component: 'NamedFileInput',
      name: 'Blood Results',
      otherProps: {},
    },
  ],
}
